/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import * as CustomWidgets from '.';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@mui/styles';
import { Avatar, Button, ButtonGroup, Card, CardContent, CardHeader, FormControlLabel, FormGroup, Grid, IconButton, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Tooltip, Typography } from '@mui/material';
import { Build, Edit, EditAttributes, Menu, Settings, AssignmentInd, Add, Delete, AddCircle, Remove, DeleteForever } from '@mui/icons-material';
import { openlightbox } from '../../util/Functions';
import DataTable from 'react-data-table-component';
import { theme, customStyles } from '../../util/TableStyles';
import { noDataComponent } from "../../util/DataObject";
import { ThemeProvider } from '@mui/material/styles';
import FormUnit from '../modals/FormUnit';
import DeleteUnit from '../modals/DeleteUnit';

const UnitList = (props) => {
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0); 
    const [limit, setLimit] = useState(5);
    const history = useHistory();

    useEffect(() => {
        init();
    }, [props.content]);

    const init = () => {
        if(props.content.units){
            setList(JSON.parse(JSON.stringify(props.content.units)));
        }

        if(props.content.hasOwnProperty('total')){
            setTotal(props.content.total);
        }

        if(props.content.hasOwnProperty('limit')){
            setLimit(props.content.limit);
        }
    }

    const openModal = (uuid, name) => {
		let modal = {
			uuid: uuid,
			name: name,
		};
		const as = <DeleteUnit
			pos={props.pos}
			changeAlert={props.changeAlert}
			changeLoader={props.changeLoader}
			contentModal={modal}
			deleteUnit={deleteUnit}
			key="deleteUnit"
		/>
		openlightbox(as);
	};

    const deleteUnit = async (uuid) => {
		props.changeLoader(true);
		let data = {};
		if (uuid) {
			data["uuid"] = uuid;
		}

		let request = await API.service("deleteUnit", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			await reloadData({});
            props.changeAlert(true, "success", "Grupo eliminado con éxito");
		}

		props.changeLoader(false);
	};

    const reloadData = async (data) => {
        props.changeLoader(true);
        let request = await API.service('adminUnits', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }
    
        props.changeLoader(false);
    };

    const createFormUnit = async (uuid) => {
        props.changeLoader(true);
        let data = {};
        if (uuid) {
            data["uuid"] = uuid;
        }
    
        let request = await API.service('formUnit', data, props.pos, props.changeAlert, props.changeLoader, history);

        if (request.status == 200 && request.data.data.response == "OK") {
            let widg = [];
            widg = request.data.data.widget;
            if (widg[0].type == 'formUnit' && widg[0].content) {
                const as = <FormUnit
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    contentModal={widg[0]?.content}
                    reloadData={reloadData}
                    key="formUnit"
                />
                openlightbox(as);
            }
        }
        props.changeLoader(false);
    };


    const paginationComponentOptions = {
		rangeSeparatorText: 'de',
		rowsPerPageText: 'Registros por página',
	};

    const blockUnblock = async (flag, uuid) => {
		props.changeLoader(true);

		let data = {
			uuid: uuid,
		};
		if (flag == "enable" || flag == "enabled") {
			data["body"] = {
				status: "disabled",
			};
		}

		if (flag == "disable" || flag == "disabled") {
			data["body"] = {
				status: "enabled",
			};
		}

		await updateUnit(data);
	};

    const updateUnit = async (data) => {
		props.changeLoader(true);
		let request = await API.service("updateUnit", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			reloadData({});
		}

		props.changeLoader(false);
	};

    const columns = [
        { selector: (row) => row.name, name: "Nombre", width: "20%", wrap: true, sortable: true },
        { selector: (row) => row.uuid, name: "UUID", width: "40%", wrap: true, sortable: true },
        {
			cell: (row) => {
				return <FormGroup>
					{
						(row.status == 'enable' || row.status == 'enabled') && 
						<FormControlLabel
							control={
								<Switch
									defaultChecked={
										row.status == 'enable' || row.status == 'enabled' ? true : false
									}
									onChange={blockUnblock.bind(this, row.status, row.uuid)}
								/>
							}
							label={
								row.status == 'enable' || row.status == 'enabled' ? 'Activo' : 
								((row.status == 'disable' || row.status == 'disabled') ? 'Inactivo' : 'N/A')
							}
						/>
					}
					{
						(row.status == 'disable' || row.status == 'disabled') && 
						<FormControlLabel
							control={
								<Switch
									defaultChecked={
										row.status == 'enable' || row.status == 'enabled' ? true : false
									}
									onChange={blockUnblock.bind(this, row.status, row.uuid)}
								/>
							}
							label={
								row.status == 'enable' || row.status == 'enabled' ? 'Activo' : 
								((row.status == 'disable' || row.status == 'disabled') ? 'Inactivo' : 'N/A')
							}
						/>
					}
				</FormGroup>
			}, name: 'Estatus', width: '20%'
		},
        {
			cell: (row) => {
				return <Typography
					fontWeight="400"
					fontFamily="Muli,sans-serif"
					color="#000000de"
					fontSize="0.875rem"
				>
					<Tooltip title="Editar">
                        <IconButton onClick={createFormUnit.bind(this, row.uuid)}>
                            <Edit/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                        <IconButton onClick={openModal.bind(this, row.uuid, row.name)}>
                            <DeleteForever/>
                        </IconButton>
                    </Tooltip>
				</Typography>
			}, name: 'Acciones', width: '20%'
		}
    ]

    const changePage = async (value) => {
		let data = {
			page: value,
			limit: limit
		}
		//setPage(p);
		await reloadData(data);
	};

	const changeTotal = async (e) => {
		let data = {
			page: 1,
			limit: e
		}
		await reloadData(data);
	};

    return <Card sx={{width: '100%', padding: '2vw'}}>
        <CardHeader
            sx={{width: '100%'}}
            title={
                <div style={{display: 'inline-flex', width: '100%'}}>
                    <Typography
                        component={'h3'} 
                        fontFamily="Muli,sans-serif"
                        fontSize="18px"
                        fontWeight={600}
                        sx={{color: '#3E3E42', width: '2%'}}
                    >
                        <AssignmentInd/>
                    </Typography>
                    <Typography
                        component={'h3'} 
                        fontFamily="Muli,sans-serif"
                        fontSize="18px"
                        fontWeight={600}
                        sx={{color: '#3E3E42', marginLeft: '0.5%'}}
                    >
                        Grupos
                    </Typography>
                </div>
            }
            action={
                <div style={{margin: '40px !important'}}>
                    <Tooltip title="Agregar grupo">
                        <IconButton sx={{marginLeft: '-50px !important', marginTop: '15px !important'}} onClick={createFormUnit.bind(this, '')}>
                            <AddCircle/>
                        </IconButton>
                    </Tooltip>
                </div>
            }
        />
        <CardContent>
            <Grid container>
                <ThemeProvider theme={theme}>
                    <DataTable
                        columns={columns} 
                        data={list}
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                        pagination
                        paginationServer
                        paginationTotalRows={total}
                        onChangePage={changePage}
                        paginationPerPage={props.content.limit}
                        paginationRowsPerPageOptions={[5,10,20,30,40,50]}
                        onChangeRowsPerPage={changeTotal}
                        noDataComponent={noDataComponent}
                    />
                </ThemeProvider>
            </Grid>
        </CardContent>
    </Card>
}

export default UnitList;